module.exports = __webpack_public_path__ + "img/DarthVader.e5d1a27.png";